import * as types from './mutation-types';

export const addInterval = ({ commit }, intervalId) => {
  commit(types.ADD_INTERVAL, intervalId)
}

export const clearIntervals = ({ commit }) => {
  commit(types.CLEAR_INTERVALS)
}
